import React, { useReducer, useContext, useMemo, useEffect } from 'react';
import { Box, TextField, Tooltip, IconButton } from '@mui/material';
import DefaultModal from '../Utils/DefaultModal';
import { api } from '../../services/api';
import { externalComponent } from '../AppRoutes';
import Table, { TableHook } from '../Table';
import { lockedReducer, checkboxShiftReducer } from '../Utils/reducers';
import ModalProdutos, { tipo } from './modalProdutos';
import { formatCurrency } from '../Utils/IntegerOnly';
import ColorButton from '../Buttons/ColorButton';
import DeleteIcon from '@mui/icons-material/Delete';
import ConfirmationDialog from '../Utils/ConfirmationDialog';
import toast from 'react-hot-toast';
import { NumericFormatInput } from '../Utils/NumericInput';
import { PercentFormatInput } from '../Utils/PercentInput';
import Checkbox from '@mui/material/Checkbox';

const submit = async (setLoader, rows, data, handleClose, reloadData) => {
    const obj = {
        produtos: rows,
        id_tabela: data.id
    }

    setLoader(true)
    const res = await api.post(`/tabelas/cria-produtos/`, obj)
    setLoader(false)
    if (res.status === 200) {
        reloadData()
    }
    handleClose()
}


const deleteRow = async (setLoader, data, id, setState, rows, reloadData) => {
    const id_tabela = id.id
    const cod = data.Cod
    const newRows = rows.filter(each => each['Cod'] !== cod)

    const obj = {
        cod: cod,
        id_tabela: id_tabela
    }

    setLoader(true)
    const res = await api.post(`/tabelas/deleta-produto/`, obj)
    setLoader(false)
    if (res.status === 200) {
        toast.success(`Código ${cod} deletado com sucesso!`)
        reloadData()
    }
    setState({ rows: newRows, deleteRow: null })
}

const deleteAllrows = async (setLoader, table, id, setState, rows, reloadData) => {
    const selectedIDs = table.apiRef.current.getSelectedRows();
    const newArray = Array.from(selectedIDs.keys())
    const filteredRows = rows.filter(row => !newArray.includes(row.Cod));
    setState({ rows: filteredRows, deleteAllRows: null })

    const id_tabela = id.id
    const obj = {
        produtos: filteredRows,
        id_tabela: id_tabela
    }

    setLoader(true)
    const res = await api.post(`/tabelas/cria-produtos/`, obj)
    setLoader(false)
    if (res.status === 200) {
        reloadData()
    }
}

const getProdutos = async (setLoader, setState, data, dispatch) => {
    setLoader(true)
    const res = await api.get(`/tabelas/produtos/${data.id}`)
    setLoader(false)
    if (res.status === 200) {

        const lista = res.data.sort((a, b) => {
            if (a.Descricao < b.Descricao) return -1;
            if (a.Descricao > b.Descricao) return 1;
            return 0;
        });

        setState({ rows: lista })

        const array_checkbox = res.data.filter(each => each['promocao'] === true).map(each => each['id'])
        dispatch({
            type: "SET_SELECTED_ROWS",
            payload: array_checkbox
        });
    }
}

const changePrice = (props, value) => {
    props.row.preco = value * 100
    props.api.forceUpdate()
}

const changeComissao = (props, value) => {
    props.row.comissao = value
    props.api.forceUpdate()
};

const changeChecked = (props, rows, data) => {
    const row = rows.find(row => row.id === props.row.id)
    let valueComissao = ''
    if (row.promocao) {
        valueComissao = tipo[data['id_tipo']]
    } else {
        valueComissao = data.comissao_promocional
    }
    row.comissao = valueComissao
    const value = { id: props.row.id, [props.field]: !props.row.promocao, comissao: valueComissao }
    row.promocao = value.promocao
    props.api.updateRows([value]);
}


const handleSelect = (id, event, dispatch, rows) => {

    if (event.shiftKey) {
        dispatch({ type: "SHIFT_SELECT", payload: { id, rows } });
    } else {
        dispatch({ type: "TOGGLE_SELECT", payload: { id } });
    }
};


const getcolumns = (data, setState, state, dispatch, patch) => {
    const columns = []
    columns.push({ field: 'Cod', headerName: 'Código', width: 100 })
    columns.push({ field: 'Descricao', headerName: 'Descrição', flex: 1 })
    columns.push({
        field: 'preco', headerName: 'Preço', width: 200,
        renderCell: (props) => {
            return (

                <Box sx={{ width: '90%' }}>
                    <TextField
                        id="valor"
                        type="text"
                        value={props.value / 100}
                        onChange={(e) => changePrice(props, e.target.value)}
                        fullWidth={false}
                        size='small'
                        sx={{ fontSize: '13px' }}
                        onKeyDown={(e) => e.stopPropagation()}
                        InputProps={{
                            inputComponent: NumericFormatInput,
                            sx: { fontSize: '13px' }
                        }}
                    />
                </Box>
            )
        }
    })
    columns.push({
        field: 'preco_minimo', headerName: 'Preço mínimo', width: 150,
        renderCell: ({ row }) => {


            let preco_minimo = (row.preco / 10000) * (100 - data.preco_minimo)
            return (
                <Box sx={{ width: '90%' }}>
                    {formatCurrency(preco_minimo)}
                </Box>
            )
        }
    })
    columns.push({
        field: 'comissao', headerName: 'Comissão padrão', width: 200,
        renderCell: (props) => {

            return (
                <Box sx={{ width: '90%' }}>
                    <TextField
                        value={props.value}
                        type="text"
                        InputProps={{
                            inputComponent: PercentFormatInput,
                            sx: { fontSize: '13px' }
                        }}
                        onChange={(e) => changeComissao(props, e.target.value)}

                    />

                </Box>
            )
        }
    })

    columns.push({
        field: 'promocao', headerName: 'Promoção', width: 100,
        renderCell: (props) => {

            return (
                <Box>
                    <Checkbox
                        checked={patch.selectedRows.has(props.row.id)} // Correção aqui
                        onClick={(e) => handleSelect(props.row.id, e, dispatch, state.rows)}
                        onChange={() => {
                            changeChecked(props, state.rows, data);

                        }}
                    />
                </Box>
            )
        }
    })

    columns.push({
        field: 'acoes',
        headerName: 'Ações',
        width: 100,
        renderCell: (props) => {
            return (
                <Box>
                    <Tooltip title='Excluir linha'><IconButton onClick={() => { setState({ deleteRow: props.row }) }}><DeleteIcon /></IconButton></Tooltip>
                </Box>
            )
        }
    })


    return columns
}

const EditProdutos = ({ data, handleClose, reloadData }) => {
    const [state, setState] = useReducer(lockedReducer, {
        productModal: null,
        deleteRow: null,
        deleteAllRows: null,
        rows: []
    })

    const [checkboxState, dispatchCheckbox] = useReducer(checkboxShiftReducer, {
        selectedRows: new Set(),
        lastSelected: null
    });

    const { setLoader } = useContext(externalComponent)

    const [table] = TableHook()

    useEffect(() => {
        getProdutos(setLoader, setState, data, dispatchCheckbox)
    }, [])

    return (
        <>

            {
                state.productModal &&
                <ModalProdutos
                    handleClose={() => setState({ productModal: null })}
                    setProducts={setState}
                    productsRow={state.rows}
                    data={data}
                />

            }

            {
                state.deleteRow &&
                <ConfirmationDialog
                    content={`Deseja deletar a linha do código ${state.deleteRow.Cod} ?`}
                    handleClose={() => setState({ deleteRow: null })}
                    onConfirm={() => deleteRow(setLoader, state.deleteRow, data, setState, state.rows, reloadData)}
                />

            }

            {
                state.deleteAllRows &&
                <ConfirmationDialog
                    content={`Deseja deletar todas as linhas selecionadas ?`}
                    handleClose={() => setState({ deleteAllRows: null })}
                    onConfirm={() => deleteAllrows(setLoader, table, data, setState, state.rows, reloadData)}
                />

            }

            <DefaultModal
                dialogProps={{ maxWidth: "xl" }}
                handleClose={handleClose}
                open={true}
                title={`Produtos`}
                content={
                    <Box sx={{ width: '100%', height: '24rem' }}>
                        <Table
                            paginationMode='client'
                            className='contabil-grid'
                            rows={state.rows}
                            columns={useMemo(() => getcolumns(data, setState, state, dispatchCheckbox, checkboxState), [state.rows, checkboxState])}
                            pagination={false}
                            rowHeight={30}
                            innerRef={table}
                            disableRowSelectionOnClick={true}
                            toolbar
                            checkbox={true}
                            slots={{
                                addComponent: () => setState({ productModal: {} }),
                                deleteComponent: () => setState({ deleteAllRows: {} })
                            }}
                            sx={{
                                maxHeight: "24rem"
                            }}
                        />
                    </Box>
                }

                action={

                    <ColorButton onClick={() => submit(setLoader, state.rows, data, handleClose, reloadData)}>Salvar</ColorButton>

                }
            />
        </>
    )
}

export default EditProdutos;